import React, { useEffect } from 'react'
import './Passenger_detail.css'
import '../../About_card/About_card.css'
import { useDispatch, useSelector } from 'react-redux'
import { getPassenger } from '../../../actions/passenger.action';
import { useParams } from 'react-router'
import i18next from 'i18next';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import InfoIcon from '@mui/icons-material/Info';
import moment from 'moment';
import { Translate } from '@mui/icons-material';
import { Tabs } from 'antd';
import { formatMonth } from '../../formatMonth';
import { API_URI } from '../../../axios';
import PageHeader from '../../page-header/PageHeader';
import Preloader from '../../Preloader';

const Passengers_detail = () => {

    const { id } = useParams()
    const { t } = useTranslation()

    const dispatch = useDispatch()
    const language = i18next.language

    useEffect(() => {
        dispatch(getPassenger(id, language))
    }, [language])

    const formatDate = () => {
        const date = new Date().toISOString()
        const month = date.split("T")[0].split("-")[1]
        return `${formatMonth(month, language)} ${moment(date).format(`DD, YYYY`)}`
    }


    const passenger_s = useSelector(state => state.passenger)

    const { passenger } = passenger_s
    const { data } = passenger
    const arrival_flights = useSelector(state => state.arrival_flights.arrival_flights)
    const departure_flights = useSelector(state => state.departure_flights.departure_flights)
    
    const items = [
        {
            key: '1',
            label: 'Вылет',
            children: <table className="table table-striped p-2">
                <tbody>
                    {
                        departure_flights.length ? departure_flights.map(item => (
                            <tr key={item}>
                                <td className='p-2'>{moment(item.departure_time).format("HH : mm")}</td>
                                <td className='p-2'>{item.destination_city}</td>
                                <td className='p-2'> <img style={{height:'23px'}} src={`${API_URI}${item.airline.logo}`} alt="" /> </td>
                                <td className='p-2'>{item.flight_number} {item.airline.name} </td>
                            </tr>
                        )) : ''
                    }
                </tbody>
            </table>
        },
        {
            key: '2',
            label: 'Прилет',
            children: <table className="table table-striped p-2">
                <tbody>
                    {
                        arrival_flights.length ? arrival_flights.map(item => (
                            <tr key={item}>
                                <td className='p-2'>{moment(item.arrival_time).format("HH : mm")}</td>
                                <td className='p-2'>{item.departure_city}</td>
                                <td className='p-2'> <img style={{height:'23px'}} src={`${API_URI}${item.airline.logo}`} alt="" /> </td>
                                <td className='p-2'>{item.flight_number} {item.airline.name} </td>
                            </tr>
                        )) : ''
                    }
                </tbody>
            </table>
        },
    ];

    const detectSection = () => {
        if (id === "2") {
            return (
                <div className="container online_table" id='onlayn_table'>
                <div className='table_box'>
                    <div className='d-flex justify-content-between mb-2'>
                        <div className='fw-bold uppercase'>
                            <Translate title='Ashgabat_International_Airport'/>, {formatDate()}
                        </div>
                        <div className='d-flex' style={{color: '#777777'}}>
                            <InfoIcon />
                            <div className='ms-2 '>Указано местное время</div>
                        </div>
                    </div>
                    <Tabs defaultActiveKey="1" items={items} />
                </div>
            </div>
            )
        }
    }


    return (
        <>
            <Helmet>
                <title>{`${t("passengers")} - ${t("Ashgabat_International_Airport")}`}</title>
            </Helmet>
            {
                data ? <div className="news-details" >
                    <PageHeader
                        title={t("passengers")}
                        breadCrumbItems={[
                            { label: t("home"), path: '/' },
                            { label: t("passengers"), path: '/passengers' },
                            { label: data?.title, path: '#' }
                        ]}
                    />
                    <div className="container py-12">
                        <div className='About_card d-flex'>
                            <div className="w-[60%] text-center" style={{ order: `2` }}>
                                <img src={`${API_URI}${data.icon}`} className='img-fluid w-25 mx-auto' alt="" />
                            </div>
                            <div className="w-100 ps-3 p-3" style={{ order: `1` }}>
                                <div className="d-flex h-100" style={{ flexDirection: 'column', justifyContent: 'center', alignContent: 'center', alignItems: 'center' }}>
                                    <h3 className="news-details__title mb-4">
                                        {data.title}
                                    </h3>

                                </div>
                            </div>
                        </div>
                        <div className="bg-white rounded-lg" style={{ boxShadow: "0px 4px 10px 0px #0000000D" }}>
                            <div className="news-details__content my-4 p-4">
                                <div className="news-details__text-1" dangerouslySetInnerHTML={{__html : data?.description}}>
                                </div>
                            </div>
                        </div>
                        {/* {detectSection()} */}
                    </div>
                </div > : <Preloader />
            }
        </>
    )
}

export default Passengers_detail